import { Component, OnInit, Input, Output}            from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import * as algolia                                   from 'algoliasearch'
import { MixService }                                 from '../mix-service.service';
import { DomSanitizer }                               from '@angular/platform-browser'

const client = algolia('UXOY6UM4BN', '0b40f33caafd7b1d1a26dc681143756f');
const mixIndex = client.initIndex('essential_mixes');

@Component({
  selector: 'app-audio-player',
  template: `
  <div [ngStyle]="{'display': mix_id.length > 0 ? 'block' : 'none'}">
    <h4 class="space" id="audio-header">Audio &amp; Tracklist</h4>
    <div class="audio_player">
      <iframe width="100%" height="60" [src]="cleanMixUrl" frameborder="0"></iframe>
    </div>
    <div class="tracklist" [ngStyle]="{'display': showTracklist ? 'block' : 'none'}" [@displayTracklist]="tracklistState">
      <ol [innerHTML]="cleanTracklist"></ol>
      <a class="close-tracklist" (click)="toggleTracklist()" [@displayTracklist]="tracklistState">Close Tracklist</a>
    </div>
  </div>
  `,
  styleUrls: ['./audio-player.component.css'],
  animations: [
    trigger('displayTracklist', [
      state('closed', style({
        height: '0%'
      })),
      state('open',   style({
        height: '*'
      })),
      transition('closed <=> open', animate('1000ms ease-in'))
    ])
  ]
})
export class AudioPlayerComponent implements OnInit {

  mix_id:string;
  mix_url:string;
  iframe_src:string;
  tracklistState: string = 'closed';
  cleanMixUrl: any = '#';
  cleanTracklist:any;
  showTracklist:boolean = false;

  constructor(private mix: MixService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.mix.currentMixId.subscribe(mix_id => {
      this.mix_id = mix_id
      this.reloadPlayer(this.mix_id)
    })
  }

  reloadPlayer(id:string) {
    mixIndex.getObject(id, (err, res) => {
      if (res.audio_player !== null) {
        this.mix_url = encodeURI(res.audio_player)
        this.iframe_src = 'https://www.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&light=1&hide_artwork=1&feed='+this.mix_url
        this.cleanMixUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframe_src)
        this.cleanTracklist = this.sanitizer.bypassSecurityTrustHtml(res.tracklist)
        this.showTracklist = true
        this.tracklistState = 'open'
      }
    })

  }

  toggleTracklist() {
    this.showTracklist = !this.showTracklist;
    this.tracklistState = 'closed'
  }

}



// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/audio-player/audio-player.component.ts